module.exports = __webpack_public_path__ + "img/tlz.c4a98b36.png";